var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 13L9.625 7L12.625 10M3.25 13H10.75C11.9926 13 13 11.9926 13 10.75V7M3.25 13C2.00736 13 1 11.9926 1 10.75V3.25C1 2.00736 2.00736 1 3.25 1H8.125M10 2.52661L11.5339 1M11.5339 1L13 2.4576M11.5339 1V4.75M5.5 4.375C5.5 4.99632 4.99632 5.5 4.375 5.5C3.75368 5.5 3.25 4.99632 3.25 4.375C3.25 3.75368 3.75368 3.25 4.375 3.25C4.99632 3.25 5.5 3.75368 5.5 4.375Z",
    stroke: "#393736",
    strokeOpacity: 0.87,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.891e5fbad784dbf2cca8a8184ac49bcb.svg";
export { ForwardRef as ReactComponent };